@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.applications.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.applications.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="key()" controlId="key" labelKey="pages.applications.fields.key" />
        }

        <app-input-block [readonly]="isEditMode()" [invalid]="isInvalid('code')" controlId="code" controlName="code"
          labelKey="pages.applications.fields.code">
          @if (hasError('code', 'required') && isInvalid('code')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.code-required' | translate }}</div>
          }
          @if (hasError('code', 'maxlength') && isInvalid('code')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.code-maxlength' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [fullWidth]="isEditMode()" [invalid]="isInvalid('name')" controlId="name" controlName="name"
          labelKey="pages.applications.fields.name">
          @if (hasError('name', 'required') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.name-required' | translate }}</div>
          }
          @if (hasError('name', 'maxlength') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.name-maxlength' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [fullWidth]="true" [invalid]="isInvalid('siteUrl')" controlId="site-url" controlName="siteUrl"
          labelKey="pages.applications.fields.site-url">
          @if (hasError('siteUrl', 'required') && isInvalid('siteUrl')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.site-url-required' | translate }}</div>
          }
          @if (hasError('siteUrl', 'maxlength') && isInvalid('siteUrl')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.site-url-maxlength' | translate }}</div>
          }
          @if (hasError('siteUrl', 'url') && isInvalid('siteUrl')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.site-url-format' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [fullWidth]="true" [invalid]="isInvalid('logoUrl')" controlId="logo-url" controlName="logoUrl"
          labelKey="pages.applications.fields.logo-url">
          @if (hasError('logoUrl', 'maxlength') && isInvalid('logoUrl')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.logo-url-maxlength' | translate }}</div>
          }
          @if (hasError('logoUrl', 'url') && isInvalid('logoUrl')) {
          <div class="invalid-feedback">{{ 'pages.applications.validation.logo-url-format' | translate }}</div>
          }
        </app-input-block>

        @if (!isIam()) {
        <app-input-block [fullWidth]="true" controlId="multi-tenant" controlName="multiTenant"
          labelKey="pages.applications.fields.multi-tenant" inputType="checkbox" />
        }

        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at"
          labelKey="pages.applications.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at"
          labelKey="pages.applications.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        <button class="btn btn-light" [disabled]="saving()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.applications.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.applications.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
